export const REQUEST_SEARCH_HIT = 'feature/searchHitCounter/REQUEST_SEARCH_HIT';
export const RECEIVE_SEARCH_HIT = 'feature/searchHitCounter/RECEIVE_SEARCH_HIT';
export const ERROR_SEARCH_HIT = 'feature/searchHitCounter/ERROR_SEARCH_HIT';
